import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import authService from '../services/authService';
import httpService from '../services/httpService';
import locationService from '../services/locationService';
import * as authActions from '../redux/actions/authActions';
import * as globalActions from '../redux/actions/globalActions';
import * as toastActions from '../redux/actions/toastActions';
import * as dialogActions from '../redux/actions/dialogActions';
import qs from 'query-string';
import axios from 'axios';
import LoaderInfo from '../components/LoaderInfo/LoaderInfo';
import _ from 'lodash';
import {Dialog} from '../components/Dialog';
import navService from '../services/navService';
import mpkEnv from '../config/env';
import NewsTicker from '../components/NewsTicker';
import Promo from '../components/Promo';

let _history = null;
let isRefreshingToken = false;
let resolveQueue = [];

const onError = (error, callback) => {
  if(error !== undefined){
    let {status, statusText, data } = error.response;
    navService.redirectTo('/error?'+qs.stringify({
      status:status,
      statusText:statusText,
      errorMessage: data.errorMessage || data.error_description || data.error || data
    }));
    callback(true);
  } else {
    callback(true);
  }
}

const logout = () => {
  authService.logout(null, window.encodeURIComponent(window.location.href));
}

const getNewAccessToken = (url, refreshToken, callback) => {
  axios.get(`${url.refreshToken.replace(':refreshToken', refreshToken)}`).then((response) => {
    setTimeout(callback);
  }, (error) => {
    onError(error, callback)
  })
}

const init = (url, credentials, ignoreAuth, onExchangeToken, callback) => {
  credentials = typeof credentials === 'function' ? credentials() : credentials;
  const defaultUri = credentials.redirect_uri;

  window.hahaahah = qs
  window.lololol = window
  let currentPath = window.location.href;
  let parsedUrl = qs.parseUrl(currentPath);
  console.log(parsedUrl)
  if(parsedUrl.query.code){
    authService.clearCookie();
    let newQuery = JSON.parse(JSON.stringify(parsedUrl.query));
    delete newQuery.code;
    delete newQuery.state;

    parsedUrl.query.redirect_uri = parsedUrl.query.redirect_uri || window.encodeURIComponent(defaultUri || parsedUrl.url + (Object.keys(newQuery).length > 0 ? ('?'+ qs.stringify(newQuery)) : ''));
    // parsedUrl.query.redirect_uri = window.btoa(parsedUrl.query.redirect_uri);

    axios.post(url.exchangeToken, parsedUrl.query).then(response => {
      delete newQuery.redirect_uri;
      let currentUrl = `${window.location.pathname}${Object.keys(newQuery).length > 0 ? `?${qs.stringify(newQuery)}` : ''}`
      callback();
      navService.redirectTo(currentUrl);
    }).catch((error) => {
      onError(error, () => {
        callback(true)
      });
    })
  } else {
    let _redirectUri = parsedUrl.query.redirect_uri || window.encodeURIComponent((defaultUri || currentPath).replace(/(?!.*(:))\/(\/)*\?/g, '?'));
    console.log(_redirectUri);
    const refreshToken = authService.getRefreshToken();
    const accessToken = authService.getAccessToken();
    if([undefined, null].indexOf(accessToken) >= 0){
      if(refreshToken){
        getNewAccessToken(url, refreshToken, callback)
      } else {
        if(ignoreAuth){
          callback();
        } else {
          if(onExchangeToken){
            onExchangeToken();
          }else{
            httpService.get({
              url:`${url.login}?redirect_uri=${_redirectUri}`
            }).then(response => {
              window.open(response.data, '_self');
            })
          }
        }
      }
    }else{
      callback();
    }
  }

  /*
  let accessToken = authService.getAccessToken();
  if(accessToken === undefined || accessToken === null){
    let currentPath = window.location.href;
    let parsedUrl = qs.parseUrl(currentPath);
    if(parsedUrl.query.code){
      let newQuery = JSON.parse(JSON.stringify(parsedUrl.query));
      delete newQuery.code;
      delete newQuery.state;

      parsedUrl.query.redirect_uri = defaultUri || parsedUrl.url + (Object.keys(newQuery).length > 0 ? ('?'+ qs.stringify(newQuery)) : '');
      parsedUrl.query.redirect_uri = window.btoa(parsedUrl.query.redirect_uri);

      axios.post(url.exchangeToken, parsedUrl.query).then(response => {
        let currentUrl = qs.parseUrl(window.location.pathname);
        callback();
        navService.redirectTo(currentUrl);
        // setTimeout(() => navService.redirectTo(currentUrl.url), 1000);
      }).catch((error) => {
        onError(error, callback);
      })
    } else {
      const _redirectUri = window.btoa(defaultUri || currentPath);
      const refreshToken = authService.getRefreshToken();

      if(refreshToken){
        // let data = parsedUrl.query;
        // data.refresh_token = refreshToken;
        getNewAccessToken(url, refreshToken, callback)
      } else {
        httpService.get({
          url:`${url.login}?redirect_uri=${_redirectUri}`
        }).then(response => {
          window.open(response.data, '_self');
        })
      }
    }
  } else {
    callback();
  }
  */
};

const setHttpInterceptors = (url, withCredentials) => {
  const setHeaders = (config) => {
    let accessToken = authService.getAccessToken();
    let accessKey = authService.getAccessKey();
    let userProfile = authService.getUserProfile();

    config.headers = config.headers || {};

    if(accessKey) config.headers['X-Access-Key'] = accessKey;
    else if(accessToken) {
      config.headers.Authorization = 'Bearer ' + accessToken;
      if(withCredentials) config.withCredentials = true
    }
    if(userProfile) config.headers['X-User-Profile'] = JSON.stringify(userProfile);
  }

  httpService.setInterceptors((config) => {
    return new Promise((resolve, reject) => {
      let accessToken = authService.getAccessToken();
      let refreshToken = authService.getRefreshToken();

      if(!accessToken && refreshToken){
        if(isRefreshingToken){
          resolveQueue.push(resolve);
        } else {
          isRefreshingToken = true;
          getNewAccessToken(url, refreshToken, () => {
            setHeaders(config);
            if(resolveQueue.length > 0){
              for(let i = resolveQueue.length - 1 ; i >= 0; i--){
                let q = resolveQueue[i];
                q(config);
                resolveQueue.splice(i, 1);
              }
            }
            isRefreshingToken = false;
          })
        }
      } else {
        setHeaders(config);
        resolve(config);
      }
    })
  });
};

const setHttpErrorHandler = () => {
  httpService.setErrorHandler( err => {
    err.statusCode = err.response ? (err.response.statusCode || err.response.status) : (err.statusCode || err.status);

    if(err.response) {
      err.response.status = err.response.status || err.response.statusCode;
      const responseData = err.response.data;
      err.response.message = responseData ? (responseData.errorMessage || responseData.error_description || responseData.message || responseData.error || responseData ) : err.message;
      err.message = err.response.message

      if (Number(err.statusCode) >= 500) {
        locationService.errorPage(err);
      } else {
        let isBreak = false;
        if(err.response.headers) {
          let authenticateErr = err.response.headers['www-authenticate'] || err.response.headers['WWW-Authenticate'];
          if(authenticateErr) {
            authenticateErr = authenticateErr.replace(/,/g, '&').replace(/"/g, '');
            let parsed = qs.parse(authenticateErr);
            err.response.message = parsed.error_description || parsed.error;
            err.message = err.response.message
            err.response.statusText = err.response.status === 401 ? 'Unauthorized' : 'Bad Request';
            locationService.errorPage(err);
            isBreak = true;
          }
        }

        if(!isBreak){
          if(err.statusCode === 401){
            if(authService.getRefreshToken()){
              locationService.errorPage(err)
            } else {
              authService.clearCookie();
              locationService.errorPage(err)
            }
          } else {
            err.message = err.response.data ? ( err.response.data.errorMessage ||  err.response.data.error_description || err.response.data.error ) : (
              err.response.body ? (err.response.body.errorMessage || err.response.body.error_description || err.response.body.error) : err.response.message
            );
            return err;
          }
        }
      }
    } else {
      locationService.errorPage({
        status:500,
        message:'Network Error'
      })
    }
  });
};

const setLogoutAction = (url, host, credentials, onLogout) => {
  let _host = typeof host === 'function' ? host() : host;
  let _credentials = typeof credentials === 'function' ? credentials() : _.clone(credentials);

  authService.setLogoutAction((redirectUri, callback) => {
    _credentials.access_token=authService.getAccessToken();
    _credentials.redirect_uri = window.encodeURIComponent(redirectUri || _credentials.redirect_uri || window.location.href);
    if(onLogout) onLogout();
    else {
      callback();
      window.open(`${_host}/auth/oauth/logout?${qs.stringify(_credentials)}`, '_self');
    }
  })
};

const onUserLoaded = (user, callback) => {
  if(window.location.pathname === '/') {
    let path;
    for(let i = 0 ; i < user.menus.length ; i++){
      let menu = user.menus[i];
      if(!path && menu.children && menu.children.length > 0){
        path = menu.children[0].path;
        break;
      }
    }
    if (path) {
      _history.push(path);
    }
    else {
      locationService.errorPage({
        status: 401,
        statusText: "Access Denied. You don't have any menu"
      })
    }
    callback(user)
  }else{
    callback(user)
  }
};

const getMe = async (url, authActions, callback, ignoreRedirect) => {
  try{
    let res = await httpService.get({url: url.me})
    authActions.setProperties({
      user:res.data,
      isLoggedIn:true,
      hasPermission: resourceUri => {
        const permission = res.data.permission || [];
        return resourceUri === '' ? true : permission.indexOf(resourceUri) >= 0;
      }
    });
    if(ignoreRedirect) callback(res.data);
    else onUserLoaded(res.data, callback);
  }catch(err){
    // callback();
    onError(err, () => callback(null));
  }
};

const setTokenNames = (callback) => {
  switch(mpkEnv.theme){
    case '66cebbca847243f422fde45a47cc619b':
      authService.setTokenNames('MPK_ACCESS_TOKEN', 'MPK_REFRESH_TOKEN');
      break;
    default:
      break;
  }

  callback();
}

export default (
  url = {
    exchangeToken:'/api/iams/exchangeToken',
    refreshToken:'/api/iams/refreshToken/:refreshToken',
    login:'/api/iams/login',
    me:'/api/iams/me'
  },
  host,
  credentials,
  history,
  onComplete,
  redirectUnauthorized=true,
  returnErrorAuthenticate=false,
  withCredentials=true
) => (WrappedComponent) => {
  class SSOLogger extends Component{
    state = {
      onProgress:true,
      newsTickers: [],
      promos: []
    }

    onUser = user => {
      if(onComplete && user ) onComplete(user, this.props);
      this.setState({onProgress: false})
      if(onComplete) onComplete(user);
    }

    onUserLoaded = (user) => {
      if(window.location.pathname === '/') {
        let path;
        for(let i = 0 ; i < user.menus.length ; i++){
          let menu = user.menus[i];
          if(!path && menu.children && menu.children.length > 0){
            path = menu.children[0].path;
            break;
          }
        }
        if (path) {
          _history.push(path);
        } else {
          if(this.props.global.asInternalService){
            locationService.errorPage({
              status: 401,
              statusText: "Access Denied. You don't have any menu"
            })
          }
        }
        this.onUser(user)
      }else{
        this.onUser(user)
      }
    };

    getMe = async () => {
      try{
        let res = await httpService.get({url: url.me})
        this.props.authActions.setProperties({
          user:res.data,
          isLoggedIn:true,
          hasPermission: (resourceUris='') => {
            if(resourceUris === '') return true;
            else{
              const permission = res.data.permission || [];
              const uris = resourceUris.split(',');
              let allowed = false
              if(uris.length === 1 && resourceUris === '') return true;
              for(let uri of uris){
                allowed = permission.indexOf(uri) >= 0;
                if(allowed) break;
              }
              return allowed;
            }
          }
        });
        setTimeout(() => {
          if(onComplete) this.onUser(res.data);
          else this.onUserLoaded(res.data);
        }, 500)
      }catch(err){
        alert(err.message)
        this.onUser();
        onError(err, () => this.onUser(null));
      }
    };

    componentWillMount(){
      let { ignoreAuth, onExchangeToken, onLogout } = this.props;
      _history = history;
      navService.init(history, this.props.globalActions);

      setTokenNames(() => {
        setHttpInterceptors(url, withCredentials);
        this.setHttpErrorHandler();
        setLogoutAction(url, host, credentials, onLogout);
        init(url, credentials, ignoreAuth, onExchangeToken, (isError) => {
          // if(isError){
          //   this.setState({onProgress:false})
          // } else {
            if(ignoreAuth) {
              this.props.authActions.setProperties({
                hasPermission: () => (true)
              })
              this.onUser(null)
            } else this.getMe();
          // }
        })
      })
      this.getResource();
    }

    setHttpErrorHandler = () => {
      let { ignoreAuth, onUnauthorized } = this.props;
      httpService.setErrorHandler( err => {
        err.statusCode = err.response ? (err.response.statusCode || err.response.status) : (err.statusCode || err.status);

        if(err.response) {
          err.response.status = err.response.status || err.response.statusCode;
          const responseData = err.response.data;
          err.response.message = responseData ? (responseData.errorMessage || responseData.error_description || responseData.message || responseData.error || responseData ) : err.message;
          err.message = err.response.message

          if (Number(err.statusCode) >= 500) {
            locationService.errorPage(err, window.location.href);
            return err;
          } else {
            let isBreak = false;
            if(err.response.headers) {
              let authenticateErr = err.response.headers['www-authenticate'] || err.response.headers['WWW-Authenticate'];
              if(authenticateErr && !err.response.data) {
                authenticateErr = authenticateErr.replace(/,/g, '&').replace(/"/g, '');
                let parsed = qs.parse(authenticateErr);
                err.response.message = parsed.error_description || parsed.error;
                err.message = err.response.data || err.response.message || err.response.headers['www-authenticate'];
                err.response.statusText = err.response.status === 401 ? 'Unauthorized' : 'Bad Request';

                if(err.message && typeof err.message === 'string' && err.message.match(new RegExp('(session timeout|token expired)', 'ig')) && (this.props.tmpObject.asWidget || this.props.global.asWidget)){
                  this.props.dialogActions.showAlert(
                    t.translate('word.message'),
                    t.translate('sentence.confirm.accessTokenExpired')
                  )
                } else {
                  if(onUnauthorized) onUnauthorized(err);
                  else{
                    if(ignoreAuth) {
                      this.props.dialogActions.showAlert(
                        t.translate('word.message'),
                        err.message
                      )
                    } else{
                      if(returnErrorAuthenticate){
                        if(err.response.status === 401) {
                          if(redirectUnauthorized) logout();
                          else locationService.errorPage(err, window.location);
                        }else return err;
                      } else {
                        locationService.errorPage(err, window.location.href);
                      }
                    }
                  }
                }

                isBreak = true;
              }
            }

            if(!isBreak){
              if(err.statusCode === 401 && !ignoreAuth){
                if(onUnauthorized) onUnauthorized(err);
                else{
                  if(redirectUnauthorized) logout();
                  else {
                    if(authService.getRefreshToken()){
                      locationService.errorPage(err, window.location)
                    } else {
                      authService.clearCookie();
                      locationService.errorPage(err, window.location)
                    }
                  }
                }
              } else {
                err.message = err.response.data ? ( err.response.data.errorMessage ||  err.response.data.error_description || err.response.data.error ) : (
                  err.response.body ? (err.response.body.errorMessage || err.response.body.error_description || err.response.body.error) : err.response.message
                );
                return err;
              }
            }
          }
        } else {
          locationService.errorPage({
            status:500,
            message:'Network Error'
          })
        }
      });
    };

    getResource = async () => {
      let { host, baseUrl, clientId, channel } = mpkEnv.portal;
      let config = {headers:{'x-client': clientId}}
      try{
        let resProduct = await fetch(`${host}${baseUrl}/api/products/es/all`, config);
        let products = await resProduct.json();
        let appUrl = products.map( d => ({
          label: d.name,
          img: d.logo.src,
          url: d.url,
          code: d.description,
        }))

        this.props.globalActions.setProperties({appUrl});
      }catch(error){
        this.props.toastActions.izi(
          t.translate('word.failed'),
          typeof error.message === 'object' ? error.message[this.props.global.localeCode] : error.message,
          'warning'
        )
      }
    }

    render(){
      return(
        <div className="mpk-full width height">
          { this.state.onProgress ? (
            <LoaderInfo statusText="getting user information.."/>
          ):(
            <div className="mpk-layout column mpk-full height">
              <WrappedComponent {...this.props}/>
              <Promo/>
              <NewsTicker/>
            </div>
          )}
          <Dialog/>
        </div>
      )
    }
  }

  return connect( state => ({
    auth: state.auth,
    global: state.global,
    tmpObject: state.tmpObject
  }), dispatch => ({
    authActions: bindActionCreators(authActions, dispatch),
    globalActions:bindActionCreators(globalActions, dispatch),
    toastActions: bindActionCreators(toastActions, dispatch),
    dialogActions: bindActionCreators(dialogActions, dispatch)
  }))(SSOLogger)
}
